
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiDialog extends Serenity.EntityDialog<UtentiRow, any> {
        protected getFormKey() { return UtentiForm.formKey; }
        protected getIdProperty() { return UtentiRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiRow.localTextPrefix; }
        protected getNameProperty() { return UtentiRow.nameProperty; }
        protected getService() { return UtentiService.baseUrl; }
        protected getDeletePermission() { return UtentiRow.deletePermission; }
        protected getInsertPermission() { return UtentiRow.insertPermission; }
        protected getUpdatePermission() { return UtentiRow.updatePermission; }

        protected form = new UtentiForm(this.idPrefix);

        constructor() {
            super();

            // Controllo della mail.
            this.form.ConfirmEmail.addValidationRule(this.uniqueName, e => {
                if (this.form.ConfirmEmail.value !== this.form.Email.value) {
                    return "Controllare la digitazione delll'indirizzo email.";
                }
            });

            //    // Controllo della password.
            //    this.form.Password.addValidationRule(this.uniqueName, e => {
            //        if (this.form.Password.value.length < 8) {
            //            return "La password deve avere lunghezza minima di 8 caratteri.";
            //        }
            //    });

            //    // Controllo della password.
            //    this.form.ConfirmPassword.addValidationRule(this.uniqueName, e => {
            //        if (this.form.ConfirmPassword.value !== this.form.Password.value) {
            //            return "Controllare la digitazione della password.";
            //        }
            //    });
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }
            else {
                var buttonSave = Q.first(buttons, x => x.cssClass == "save-and-close-button");
                var oldSaveClick = buttonSave.onClick;
                buttonSave.onClick = e => { this.confirmBeforeSave(oldSaveClick, e); };
            }

            return buttons;
        }

        private confirmBeforeSave(oldEvt, e) {
            if (this.form.Classi.value === undefined || this.form.Classi.value === "")
                Q.alert("Bisogna attribuire almeno una classe!");
            else
                oldEvt(e);
        }

        onSaveSuccess(response: Serenity.SaveResponse) {
            if (response.EntityId > 0) {
                UtentiService.Retrieve({
                    EntityId: response.EntityId
                },
                    response => {
                        ExtendedEndpointService.InviaMailAttivazione({
                            Token: response.Entity.Token,
                            Email: response.Entity.Email
                        },
                            response => {
                            },
                            {
                                async: false
                            });
                    },
                    {
                        async: false
                    });
            }
        }
    }
}